import React from "react";
import {
  ALL_REPOSITORIES,
  ALL_TEMPLATES,
  SEARCH_MODES,
  formatCount,
} from "./searchModes";

function repositoryLabel(repository) {
  if (!repository) return "Repository";
  return (
    repository.FolderName ||
    repository.folderName ||
    repository.repositoryName ||
    repository.RepositoryName ||
    repository.name ||
    `Repository ${repository.RepositoryId || repository.repositoryId || ""}`
  );
}

function repositoryId(repository) {
  const value =
    repository.RepositoryId !== undefined
      ? repository.RepositoryId
      : repository.repositoryId !== undefined
        ? repository.repositoryId
        : repository.id;
  return value === undefined || value === null ? "" : String(value);
}

/**
 * Repository + index template pickers shared by every mode. Index Search needs one template (its fields come
 * from it); the other modes treat "All index templates" as a global search.
 */
export default function ScopeBar({
  mode,
  repositories,
  templates,
  repositoryId: selectedRepositoryId,
  templateName,
  onRepositoryChange,
  onTemplateChange,
  summary,
  disabled,
}) {
  const indexMode = mode === SEARCH_MODES.INDEX;
  const sortedTemplates = (templates || [])
    .filter((template) => template && template.tableName)
    .slice()
    .sort((a, b) =>
      String(a.displayName || a.tableName).localeCompare(
        String(b.displayName || b.tableName),
      ),
    );

  return (
    <div className="ds-scope" role="group" aria-label="Search scope">
      <div className="ds-scope-field">
        <label htmlFor="scopeRepository">Repository</label>
        <select
          id="scopeRepository"
          className="ds-select"
          value={selectedRepositoryId || ALL_REPOSITORIES}
          disabled={disabled}
          onChange={(event) => onRepositoryChange(event.target.value)}
        >
          <option value={ALL_REPOSITORIES}>All repositories</option>
          {(repositories || []).map((repository) => (
            <option
              key={repositoryId(repository) || repositoryLabel(repository)}
              value={repositoryId(repository)}
            >
              {repositoryLabel(repository)}
            </option>
          ))}
        </select>
      </div>
      <div className="ds-scope-field">
        <label htmlFor="scopeTemplate">Index template</label>
        <select
          id="scopeTemplate"
          className="ds-select"
          value={templateName || ALL_TEMPLATES}
          disabled={disabled}
          onChange={(event) => onTemplateChange(event.target.value)}
        >
          <option value={ALL_TEMPLATES}>
            {indexMode
              ? "All index templates (shared fields: Block, Lot)"
              : "All index templates (global)"}
          </option>
          {sortedTemplates.map((template) => (
            <option key={template.tableName} value={template.tableName}>
              {String(template.displayName || template.tableName).trim()}
            </option>
          ))}
        </select>
      </div>
      <div className="ds-scope-summary" aria-live="polite">
        {summary ||
          (indexMode
            ? "Pick an index template to see its search fields."
            : `Searching ${templateName ? "one index template" : `all ${formatCount(sortedTemplates.length)} index templates you can access`}.`)}
      </div>
    </div>
  );
}
